/**
 * Compact controls for a page's top bar (Students, Staff, Guardians): 32px tall, 14px text.
 * Use toolbarButtonSx on buttons (spread it to add e.g. a margin) and toolbarFieldsSx on a wrapper
 * around selects / text fields.
 */
export const toolbarButtonSx = { minWidth: 80, height: 32, fontSize: 14 };

export const toolbarFieldsSx = {
  "& .MuiInputBase-root": { height: 32, fontSize: 14 },
  "& .MuiSelect-select": { py: 0, fontSize: 14 },
  "& .MuiInputLabel-root": { fontSize: 14 },
  // date pickers (MUI X v8) render their own input, not MuiInputBase
  "& .MuiPickersInputBase-root": { height: 32, fontSize: 14 },
  "& .MuiPickersSectionList-root": { py: 0 },
  "& .MuiFormControl-root": { minWidth: 90 },
};

/**
 * Hint tooltip for a top-bar field: soft light card (low contrast), small text, arrow, under the field.
 * Usage: <Tooltip title="…" {...fieldHintTooltipProps}>
 */
export const fieldHintTooltipProps = {
  arrow: true,
  placement: "bottom" as const,
  enterDelay: 300,
  slotProps: {
    tooltip: {
      sx: {
        bgcolor: "grey.100",
        color: "text.secondary",
        border: 1,
        borderColor: "grey.300",
        boxShadow: 1,
        fontSize: 12,
        fontWeight: 400,
        lineHeight: 1.4,
        px: 1.25,
        py: 0.75,
        maxWidth: 240,
      },
    },
    arrow: { sx: { color: "grey.100", "&::before": { border: 1, borderColor: "grey.300" } } },
  },
};
